<ng-container *transloco="let t;">
    <form [formGroup]="documentFieldForm" (ngSubmit)="createOrUpdateFields()">
        <div class="modal-header mb-0 d-flex justify-content-between align-items-center px-2 py-1">
            <h5 class="modal-title" id="exampleModalLabel">{{  form.id.value ? t('Meta data - Edit sidebar header - Edit field') : t('Meta data - Add metadata sidebar header - Add field') }}</h5>
            <div class="d-flex justify-content-between align-items-center text-dark cursor-pionter">
                <span placement="auto" class="cursor-pointer" container="body" [autoClose]="true" triggers="hover" ngbTooltip="Close" (click)="closeSidebar()">
                    <i data-feather="x" [size]="16" data-dismiss="modal" aria-label="Close"></i>
                </span>
            </div>
        </div>
        <div class="modal-body flex-grow-1 p-0">
            <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="documentField-scroll-contentContainer">
                <div class="px-2 py-1">
                    <div class="form-group">
                        <label class="form-label" for="Name">{{ t('Meta data form field title - (Meta data section) - Name') }}</label>
                        <input
                            type="text"
                            class="form-control dt-full-name"
                            id="Name"
                            [placeholder]="t('Meta data form field title - (Meta data section) - Name')"
                            formControlName="meta_data_name"
                            aria-describedby="Name"
                            [ngClass]="{ 'is-invalid error': submitted && form.meta_data_name.errors }"
                        />
                        <div *ngIf="submitted && form.meta_data_name.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.meta_data_name.errors }">
                            <div *ngIf="form.meta_data_name.errors.required">{{t('Field required (form validation) - Field name is required', { fieldName: t('Meta data form field title - (Meta data section) - Name') })}}</div>
                        </div>
                    </div>
                    @if(['text', 'datepicker', 'droplist'].includes(form.meta_data_type.value)){
                        <div class="form-group">
                            <label class="form-label" for="Name">{{ t('Meta data form field title - (Meta data section) - Placeholder') }}</label>
                            <input
                                type="text"
                                class="form-control dt-full-name"
                                id="Name"
                                [placeholder]="t('Meta data form field title - (Meta data section) - Placeholder')"
                                formControlName="placeholder"
                                aria-describedby="placeholder"
                            />
                        </div>
                    }

                    <div class="form-group"  [ngClass]="{'disabled' : form.id.value !== '' || view === 'modal'}">
                        <label for="customSelect">{{ t('Meta data form field title - (Meta data section) - Section') }}</label>
                        <ng-select
                            [items]="sections"
                            bindLabel="label"
                            bindValue="value"
                            [readonly]="readonly"
                            formControlName="section"
                            [searchable]="searchable"
                            [placeholder]="t('Meta data form field placeholder - (Meta data section) - Select section')"
                        ></ng-select>
                    </div>
                    
                    <div class="form-group" [ngClass]="{'disabled' : (form.id.value !== '' || (form.section.value === metaDataSectionEnum.USER_FIELD || form.section.value === metaDataSectionEnum.PRODUCT_FIELD))}">
                        <label for="customSelect">{{ t('Meta data form field title - (Meta data section) - Type of field') }}</label>
                        <ng-select
                            [items]="includeOrFieldtype | filterMetadataTypes : form.section.value"
                            bindLabel="label"
                            bindValue="value"
                            [readonly]="readonly"
                            formControlName="meta_data_type"
                            [searchable]="searchable"
                            [placeholder]="t('Meta data form field placeholder - (Meta data section) - Select type')"
                            [ngClass]="{ 'is-invalid error': submitted && form.meta_data_type.errors }"
                        >
                        </ng-select>
                        <div *ngIf="submitted && form.meta_data_type.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.meta_data_type.errors }">
                            <div *ngIf="form.meta_data_type.errors.required">{{t('Field required (form validation) - Field name is required', { fieldName: t('Meta data form field title - (Meta data section) - Type of field') })}}</div>
                        </div>
                    </div>
                    @if(form.meta_data_type.value === 'text' && !form.api_field.value){
                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="multiple_line_field" formControlName="multiple_line_field" />
                                <label class="custom-control-label" for="multiple_line_field">{{t("Meta data field section text - (Meta data section) - Allow multiple rows")}}</label>
                            </div>
                        </div>
                    }
                    @else if(form.meta_data_type.value === 'droplist'){
                        <div class="form-group" [ngClass]="{'disabled' : form.id.value !== ''}">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="multiSelectDroplist" formControlName="multi_select" />
                                <label class="custom-control-label" for="multiSelectDroplist">{{ t('Meta data field check box label text - (Meta data section) - Droplist with Multiple Options') }}</label>
                            </div>
                        </div>    
                    }
                    
                    <div *ngIf="form.meta_data_type.value === 'text' && form.section.value === 'document_field'">
                        <div class="form-group">
                            <label>{{ t('Meta data form field title - (Meta data section) - Edit Validation') }}</label>
                            <ng-select
                                [items]="editValidation"
                                bindLabel="label"
                                bindValue="value"
                                [readonly]="readonly"
                                formControlName="validation_type"
                                [searchable]="searchable"
                                [placeholder]="t('Meta data form field placeholder - (Meta data section) - Select Validation Type')"
                            >
                            </ng-select>
                        </div>

                        <!-- Numbers -->
                        <div class="number-validation-section" *ngIf="form.validation_type.value === 'numbers'">
                            <div class="form-group">
                                <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Select Type') }}</label>
                                <ng-select
                                    [items]="numberValidationtype"
                                    bindLabel="label"
                                    bindValue="value"
                                    [readonly]="readonly"
                                    [placeholder]="t('Meta data form field title - (Meta data section) - Select Type')"
                                    formControlName="number_validation_type"
                                    [searchable]="searchable"
                                >
                                </ng-select>
                            </div>

                            <div class="form-group number-validation-box" *ngIf="form.number_validation_type.value">
                                <div>
                                    <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Min') }}</label>
                                    <input type="number" class="form-control" formControlName="min" aria-describedby="" />
                                </div>
                                <div>
                                    <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Max') }}</label>
                                    <input type="number" class="form-control" formControlName="max" aria-describedby="" />
                                </div>
                                <div *ngIf="form.number_validation_type.value !== 'numbers_characters'">
                                    <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Decimals') }}</label>
                                    <input type="number" class="form-control" formControlName="decimals" aria-describedby="" />
                                </div>
                            </div>
                        </div>
                        <!-- / Numbers -->

                        <!-- Letters or Numbers & Letters -->
                        <div class="form-group" *ngIf="form.validation_type.value === 'letters' || form.validation_type.value === 'numbers_letters'">
                            <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Total Character') }}</label>
                            <input type="number" class="form-control" formControlName="max" aria-describedby="" />
                        </div>
                        <!-- / Letters or Numbers & Letters -->

                        <!-- Custom Validation -->
                        <div class="custom-validation-section" *ngIf="form.validation_type.value === 'custom_regex_validation'">
                            <div class="form-group">
                                <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Regular Expression') }}</label>
                                <input type="text" class="form-control" formControlName="regular_expression" aria-describedby="" />
                            </div>

                            <div class="form-group">
                                <label class="form-label">{{ t('Meta data form field title - (Meta data section) - Validation help text') }}</label>
                                <input type="text" class="form-control" formControlName="validation_help_text" aria-describedby="" />
                            </div>
                        </div>
                        <!-- / Custom Validation -->
                    </div>

                    <div class="form-group" *ngIf="form.meta_data_type.value === 'image'">
                        <label class="form-label" for="APIAttribute">{{ t('Delete attachment after days text (Meta data section) - Automatic delete after days') }}</label>
                        <input type="number" class="form-control dt-full-name" id="expire_days" [placeholder]="t('Image field deletion days placeholder text (Meta data section) - Number of days')" formControlName="expire_days" aria-describedby="ExpireDays" />
                    </div>

                    <div class="form-group">
                        <label class="form-label" for="APIAttribute">{{ t('Meta data form field title - (Meta data section) - Api attribute') }}</label>
                        <input type="text" class="form-control dt-full-name" id="Name" [placeholder]="t('Meta data form field title - (Meta data section) - Api attribute')" formControlName="api_attribute" aria-describedby="APIAttribute" />
                    </div>

                    <div class="form-group" *ngIf="form.section.value === metaDataSectionEnum.PERSON_FIELD || form.section.value === metaDataSectionEnum.ORGANIZATION_FIELD">
                        <label class="form-label" for="hint">{{ t('Hint field title - (Meta data section) - Hint') }}</label>
                        <input type="text" class="form-control dt-full-name" [placeholder]="t('Hint field title - (Meta data section) - Hint')" formControlName="hint" aria-describedby="hint" />
                    </div>

                    <div class="form-group mb-0">
                        <label for="Description">{{ t('Meta data form field title - (Meta data section) - Description') }}</label>
                        <fieldset class="form-group">
                            <textarea
                                class="form-control"
                                id="Description"
                                rows="2"
                                formControlName="meta_data_description"
                                [placeholder]="t('Meta data form field placeholder - (Meta data section) - Enter your description here')"
                            ></textarea>
                        </fieldset>
                    </div>

                    @if(form.meta_data_type.value === 'text' && form.section.value === 'document_field'){
                        <div class="form-group">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="api_field" formControlName="api_field" />
                                <label class="custom-control-label" for="api_field">{{t("Meta data API field checkbox - (Meta data section) - API field")}}</label>
                            </div>
                        </div>    
                        @if(form.api_field.value === true){
                            <div class="form-group">
                                <label class="form-label" for="api_url">{{ t('Meta data API url text - (Meta data section) - API url') }}</label>
                                <input type="text" class="form-control dt-full-name" id="api_url" [placeholder]="t('Meta data API url text - (Meta data section) - API url')" formControlName="api_url" aria-describedby="api_url" [ngClass]="{ 'is-invalid error': submitted && form.api_url.errors }"/>
                                <div *ngIf="submitted && form.api_url.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.api_url.errors }">
                                    <div *ngIf="form.api_url.errors.required">
                                        {{ t('Field required (form validation) - Field name is required', { fieldName: t('Meta data API url text - (Meta data section) - API url') }) }}
                                    </div>
                                    <div *ngIf="form.api_url.errors.pattern">
                                        {{ t('Invalid URL message (General section) - Please enter a valid URL') }}
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label" for="api_key">{{ t('Meta data API key text - (Meta data section) - API key') }}</label>
                                <input type="text" class="form-control dt-full-name" id="api_key" [placeholder]="t('Meta data API key text - (Meta data section) - API key')" formControlName="api_key" aria-describedby="api_key" [ngClass]="{ 'is-invalid error': submitted && form.api_key.errors }"/>
                                <div *ngIf="submitted && form.api_key.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && form.api_key.errors }">
                                    <div *ngIf="form.api_key.errors.required">{{t('Field required (form validation) - Field name is required', { fieldName: t('Meta data API key text - (Meta data section) - API key') })}}</div>
                                </div>
                            </div>
                        }
                    }

                    <!-- Multi Choice Options -->
                    <div class="drop-list-options" *ngIf="form.meta_data_type.value === 'droplist'">
                        <ul ngbNav #navJustified="ngbNav" class="nav-tabs nav-justified">
                            <li ngbNavItem>
                                <a ngbNavLink>{{ t('Meta data form create options tab title - (Meta data section) - Create options') }}</a>
                                <ng-template ngbNavContent>
                                    <div class="form-group">
                                        <div formArrayName="options">
                                            <ng-container *ngFor="let option of optionsControl.controls; let i = index">
                                                <div class="form-group" [formGroup]="option">
                                                    <div class="multi-choice-row">
                                                        <label class="form-label">{{ t('Meta data form create options tab option field title - (Meta data section) - Option') }}</label>
                                                        <div class="multi-choice-rowItem">
                                                            <div class="multiChoiceInput-fields">
                                                                <input class="form-control" formControlName="name" />
                                                                <div *ngIf="submitted && option.get('name')?.errors" class="invalid-feedback" [ngClass]="{ 'd-block': submitted && option.get('name')?.errors }">
                                                                    <div *ngIf="option.get('name')?.errors?.required">{{t('Field required (form validation) - Field name is required', { fieldName: t('Meta data form create options tab option field title - (Meta data section) - Option') })}}</div>
                                                                </div>
                                                            </div>
                                                            <div class="multiChoiceIcon">
                                                                <span (click)="toggleValueField(i,0)" *ngIf="option.value.show === 1">
                                                                    <i class="action-btnMultiChoice" data-feather="minus"></i>
                                                                </span>
                                                                <span (click)="toggleValueField(i,1)" *ngIf="option.value.show === 0">
                                                                    <i class="action-btnMultiChoice" data-feather="plus"></i>
                                                                </span>
                                                            </div>
                                                            <div class="multiChoiceInput-fields" *ngIf="option.value.show">
                                                                <input class="form-control" formControlName="value" />
                                                            </div>
                                                            <div class="multiChoiceIcon" *ngIf="i > 0" (click)="removeOption(i)">
                                                                <i class="action-btnMultiChoice" data-feather="trash"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <button type="button" class="btn p-0 me-auto btn-sm mt-0 btn-transparent addMultiChoiceOptionBtn text-primary" (click)="addOption({})">
                                            {{ t('Meta data form create options tab add option button text - (Meta data section) - Add option') }}
                                        </button>
                                    </div>
                                </ng-template>
                            </li>
                            <li ngbNavItem>
                                <a ngbNavLink>{{ t('Meta data form import options tab title - (Meta data section) - Import options') }}</a>
                                <ng-template ngbNavContent>
                                    <div class="import-option-tab">
                                        <div class="form-control-row mb-0">
                                            <div class="import-option-uploadFile" (click)="fileInput.click()">
                                                <input type="file" accept=".json" hidden #fileInput (change)="onFileSelected($event)" />
                                                <p class="file-name">
                                                    {{ droplistJsonFileName || t('Meta data form import options tab title - (Meta data section) - No Upload file') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </li>
                        </ul>
                        <div [ngbNavOutlet]="navJustified" class="mt-2"></div>
                    </div>
                    <!-- / Multi Choice Options -->

                    <button type="submit" class="btn btn-primary me-50" rippleEffect>
                        <span *ngIf="loading" class="spinner-border spinner-border-sm me-50"></span>{{ form.id.value ? t('Update button text (update button) - update') : t('Add button title (add button) - Add') }}
                    </button>
                    <button type="reset" class="btn btn-outline-secondary" (click)="closeSidebar()" rippleEffect>
                        {{ t('Cancel button text (cancel button) - cancel') }}
                    </button>
                </div>
            </ng-scrollbar>
        </div>
    </form>
</ng-container>
